document.addEventListener("DOMContentLoaded", () => {
  const cards = document.querySelectorAll(".card-product--variant-swatches");
  if (!cards.length) return;

  const getGapValue = (element) => {
    const styles = getComputedStyle(element);
    const gapValue = parseFloat(styles.columnGap || styles.gap || "0");
    return Number.isNaN(gapValue) ? 0 : gapValue;
  };

  const setImage = (image, src) => {
    if (!image || !src) return;
    image.src = src;
    image.srcset = src;
  };

  const initVariantSlider = (card) => {
    const variantsInner = card.querySelector(
      ".featured-collection-card__variants-inner"
    );
    if (!variantsInner) return;

    const variantButtons = Array.from(
      variantsInner.querySelectorAll(".featured-collection-card__variant")
    );
    const total = variantButtons.length;
    if (!total) return;

    const variantsTrack = variantsInner.closest(
      ".featured-collection-card__variants-track"
    );
    if (variantsTrack) {
      variantsTrack.classList.toggle("has-overflow", total > 6);
    }

    const visibleCount = Math.min(6, total);
    const buttonWidth = variantButtons[0].getBoundingClientRect().width || 0;
    const step = buttonWidth + getGapValue(variantsInner);

    const updateSliderPosition = (activeIndex) => {
      if (total <= visibleCount || !step) {
        variantsInner.style.transform = "translateX(0px)";
        return;
      }

      let startIndex = 0;

      if (activeIndex >= 3) {
        startIndex = Math.min(activeIndex - 2, total - visibleCount);
      }

      variantsInner.style.transform = `translateX(${-startIndex * step}px)`;
    };

    updateSliderPosition(0);
    variantButtons.forEach((btn, index) => {
      btn.addEventListener("click", () => updateSliderPosition(index));
    });
  };

  const initCard = (card) => {
    const img = card.querySelector(".card-product__image");
    if (!img) return;

    const secondaryImg = card.querySelector(".card-product__image--secondary");
    const primarySrc =
      card.dataset.primaryImage || img.currentSrc || img.getAttribute("src");
    const secondarySrc =
      card.dataset.secondaryImage ||
      (secondaryImg && (secondaryImg.currentSrc || secondaryImg.getAttribute("src"))) ||
      "";

    if (!secondaryImg && secondarySrc) {
      card.addEventListener("mouseenter", () => {
        const activeVariantImage = card.dataset.activeVariantImage;
        setImage(img, activeVariantImage || secondarySrc);
      });

      card.addEventListener("mouseleave", () => {
        setImage(img, card.dataset.activeVariantImage || primarySrc);
      });
    }

    const variantButtons = card.querySelectorAll(
      ".featured-collection-card__variant"
    );

    variantButtons.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();

        const variantImage = btn.dataset.variantImage;
        if (!variantImage) return;

        setImage(img, variantImage);
        setImage(secondaryImg, variantImage);
        card.dataset.activeVariantImage = variantImage;

        variantButtons.forEach((button) =>
          button.classList.remove("active")
        );
        btn.classList.add("active");
      });

      btn.addEventListener("mousedown", (e) => e.stopPropagation());
    });

    initVariantSlider(card);
  };

  cards.forEach((card) => initCard(card));
});
